// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables() {
  
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_currentAccountV5_profile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["IndividualAccountProfile"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"currentAccountV5_profile_IndividualAccountProfile_agent_website":{"b":""},"currentAccountV5_profile":{"u":"response_currentAccountV5_profile"}}};

let wrapResponseConverterMap = {
  response_currentAccountV5_profile: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"currentAccountV5_profile_IndividualAccountProfile_agent_website":{"b":""},"currentAccountV5_profile":{"u":"response_currentAccountV5_profile"}}};

let responseConverterMap = {
  response_currentAccountV5_profile: unwrap_response_currentAccountV5_profile
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function accountMemberRole_decode($$enum) {
  if ($$enum === "ASSISTANT" || $$enum === "UNKNOWN" || $$enum === "ASSOCIATE" || $$enum === "TRANSACTION_COORDINATOR" || $$enum === "BUYER_SPECIALIST" || $$enum === "SHOWING_ASSISTANT" || $$enum === "CLIENT_CARE_COORDINATOR" || $$enum === "PARTNER" || $$enum === "INSIDE_SALES_AGENT" || $$enum === "OWNER" || $$enum === "LISTING_MANAGER" || $$enum === "OPERATIONS_MANAGER" || $$enum === "LISTING_SPECIALIST" || $$enum === "MARKETING_SPECIALIST") {
    return $$enum;
  }
}

let accountMemberRole_fromString = accountMemberRole_decode;

let Utils = {
  accountMemberRole_decode: accountMemberRole_decode,
  accountMemberRole_fromString: accountMemberRole_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerProfileRole",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "brokerage",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedProfileConversionQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "AccountV5",
          "kind": "LinkedField",
          "name": "currentAccountV5",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v0/*: any*/),
              "action": "THROW"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Agent",
                      "kind": "LinkedField",
                      "name": "agent",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "IndividualAccountProfile",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UnifiedProfileConversionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountV5",
        "kind": "LinkedField",
        "name": "currentAccountV5",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "IndividualAccountProfile",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6655817d100177e046e6598ca8b239d",
    "id": null,
    "metadata": {},
    "name": "UnifiedProfileConversionQuery",
    "operationKind": "query",
    "text": "query UnifiedProfileConversionQuery {\n  currentAccountV5 {\n    viewerProfileRole\n    profile {\n      __typename\n      ... on IndividualAccountProfile {\n        agent {\n          brokerage\n          website\n          nodeId\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_currentAccountV5_profile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_currentAccountV5_profile = unwrap_response_currentAccountV5_profile;
exports.wrap_response_currentAccountV5_profile = wrap_response_currentAccountV5_profile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
